import { allBanks } from "./BanksReducer";
import { SelectedCandidates } from "./CandidateReducer";
import { combineReducers } from "redux";
import { isLogin } from "./AuthReducer";
import { allParams, conditionsParams, selectedParams, symboledParams } from "./ParamsReducer";

export const reducers = combineReducers({
  isLogin,
  allParams,
  SelectedCandidates,
  allBanks,
  selectedParams,
  symboledParams,
  conditionsParams
}); 
